function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      // eslint-disable-next-line no-mixed-operators
      var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
}

export const newTrade = (information) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        const firestore = getFirestore();
        const ref = firestore.collection('trading-book').doc(information.uid);
        const documentID = uuidv4();

        ref.set({
            [documentID]: information
        }, {merge: true}).then(() => {
            dispatch({ type: 'ADD_TO_TRADE_BOOK', information });
        }).catch((err) => {
            dispatch({ type: 'FAILED_TRADE_BOOK', err });
        });
    }
}

// caution: this won't work
export const deleteTrade = (information) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        const firestore = getFirestore();
        const ref = firestore.collection('trading-book').doc(information.uid);

        ref.update({
            [information.type]: firestore.FieldValue.arrayRemove(information)
        }).then(() => {
            dispatch({ type: 'DELETE_FROM_TRADE_BOOK', information });
        }).catch((err) => {
            dispatch({ type: 'FAILED_TRADE_BOOK', err });
        });
    }
}